<script>
import { mapActions, mapGetters } from 'vuex'

import logger from '@/utils/logger'
import WindowSize from '@/mixins/window-size'
import { parseQueryString } from '@/utils/query-string'
import LavenderMixin from '@/mixins/lavender'

import SingleCheckoutToast from '@/views/checkout/single-checkout/mobile/components/toast.vue'

import { isNetworkError } from './utils/network'

export default {
  name: 'App',
  components: { SingleCheckoutToast },
  mixins: [WindowSize, LavenderMixin],
  computed: {
    ...mapGetters(['shouldDisplayComponentV5']),
    ...mapGetters('application', ['isEmbedded', 'isArabic']),
    ...mapGetters('session', [
      'order',
      'isInstalmentOrder',
      'singleCheckoutRevampEnabled',
    ]),
    ...mapGetters('configuration', ['isSimpleCheckoutEnabled']),
    appClass() {
      // The app will not work smoothly when user use the Salla App on OPPO device
      const oppoWebviewClass = 'h440:pt-60'
      // TODO: This is the old layout. It is using for paylater method. We will remove this after update new UI
      const payLaterClass = 'md:pt-0'
      // This is wrapper class to define some classes which is support iframe mode
      const checkoutIframeClass = this.isEmbedded ? 'checkout-iframe' : ''
      // TODO: This one is new UI layout
      const newLayoutClass = 'pt-0'
      const mainLayout = this.isInstalmentOrder ? newLayoutClass : payLaterClass
      const uqudoClass =
        this.$route?.name === 'uqudo-verification' ? 'uqudo-idv' : ''

      return [
        'tamara-application',
        this.shouldDisplayComponentV5 || this.singleCheckoutRevampEnabled
          ? 'tamara-application--v5'
          : 'tamara-application--current',
        this.isArabic ? 'tamara-application--rtl' : 'tamara-application--ltr',
        this.singleCheckoutRevampEnabled
          ? 'tamara-application--enabled-single-checkout-revamp'
          : '',
        this.isMobile ? 'is-mobile' : 'is-desktop',
        this.isSimpleCheckoutEnabled ? 'tamara-application--v6' : '',
        this.isLavenderReskinEnabled ? 'lavender' : '',
        mainLayout,
        oppoWebviewClass,
        checkoutIframeClass,
        uqudoClass,
      ]
    },
    isSupportFlexbox() {
      return 'CSS' in window && CSS.supports('display', 'flex')
    },
  },
  watch: {
    isArabic() {
      this.setDirection()
    },
  },
  created() {
    this.setDirection()
  },
  async mounted() {
    const query = parseQueryString(window.location.search)
    const { di = false } = query || {}

    if (di) {
      this.setDeepIntegration(di)

      this.handleDeepIntegrationAuth()
    }
    setTimeout(() => {
      document.getElementById('appWrapper').style.display = 'block'
      document.getElementById('loadingPlaceholder').style.display = 'none'
    }, 300)
  },
  methods: {
    ...mapActions('application', ['setDeepIntegration']),
    ...mapActions('auth', ['authenticateByCheckoutId']),
    setDirection() {
      this.$vuetify.rtl = this.isArabic
    },
    async handleDeepIntegrationAuth() {
      const { checkoutId } = this

      try {
        await this.authenticateByCheckoutId(checkoutId)

        this.$router.push({ name: 'checkout', query: { ...this.$route.query } })
      } catch (error) {
        logger.error(error, { deepIntegration: true, welcome: true })

        if (!isNetworkError(error)) {
          return this.$router.replace({
            path: '/404',
            query: { ...this.$route.query },
          })
        }
      }
    },
  },
}
</script>

<template>
  <div v-if="isSupportFlexbox">
    <SingleCheckoutToast />
    <v-app id="app" :class="[appClass, 'min-h-screen']">
      <router-view />
    </v-app>
  </div>
  <div v-else class="w-screen h-screen text-center pt-15vh">
    Your browser is not supported
  </div>
</template>
